import { useMutation, useQueryClient } from '@tanstack/react-query';

type DeleteAdminOrganizationParams = {
  id: number;
};

export default function useDeleteAdminOrganization() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: DeleteAdminOrganizationParams) => {
      const response = await fetch(`/admin/api/organizations/${params.id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        const message =
          response.status === 403
            ? '権限がありません'
            : ((body as { error?: string }).error ?? '企業の削除に失敗しました');
        throw new Error(message);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'organizations'] });
    },
  });
}
